import React from 'react';

export default () => (
  <div className="loading-wrapper">
    <em className="fas fa-circle-notch fa-spin fa-2x text-muted" />
  </div>
);
